import { Directive, HostListener, inject, Input } from '@angular/core';
import { SideDialogRef } from './side-dialog-ref.class';

@Directive({
  selector: 'side-dialog-title',
  host: {
    class: 'side-dialog-title',
  },
})
export class SideDialogTitleDirective {}

@Directive({
  selector: 'side-dialog-content',
  host: {
    class: 'side-dialog-content',
  },
})
export class SideDialogContentDirective {}

@Directive({
  selector: 'side-dialog-actions',
  host: {
    class: 'side-dialog-actions',
  },
})
export class SideDialogActionsDirective {}

@Directive({
  selector: '[side-dialog-close]',
  host: {
    class: 'side-dialog-close',
  },
})
export class SideDialogCloseDirective {
  @Input('side-dialog-close') dialogResults: any;

  private _dialogRef: SideDialogRef = inject(SideDialogRef);

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    this._dialogRef.close(this.dialogResults);
  }
}
